import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

const findPaymentNoticeMessages = createAsyncThunk(
  "paymentNoticeDetail/findPaymentNoticeMessages",
  async (id: number, { getState, rejectWithValue }) => {
    try {
      const url = new URL(`${api.baseURL}message`);
      url.searchParams.append(
        "where",
        JSON.stringify({
          room: id,
        }),
      );
      url.searchParams.append("sort", "createdAt DESC");
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(url.toJSON(), {
        method: "GET",
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export default findPaymentNoticeMessages;
